module.exports = __webpack_public_path__ + "static/img/nav-logo.e6a8bb97.svg";